import {
  WEBSTORY_FETCH_DATA_SUCCESS,
  WEBSTORY_ARE_LOADING,
  WEBSTORY_HAVE_ERROR,
} from "../actionType";
import HttpService from "../../utils/httpService";
import { Get } from "../../services/api.service";

// Action creator function to handle different types of home primary actions
export function webstoryAction(action, payload) {
  switch (action) {
    case WEBSTORY_HAVE_ERROR:
      return {
        type: action,
        hasError: payload,
      };

    case WEBSTORY_ARE_LOADING:
      return {
        type: action,
        isLoading: payload,
      };

    case WEBSTORY_FETCH_DATA_SUCCESS:
      return {
        type: action,
        homePrimary: payload,
      };

    default:
      return;
  }
}

// Async action creator function to fetch home primary data
export function WebStoryFetchData(start, limit, category_name) {
  return (dispatch) => {
    try {
      // Dispatch action indicating data is loading
      dispatch(webstoryAction(WEBSTORY_ARE_LOADING, true));

      // Check if home primary data is available in local storage
      if (localStorage.getItem("SandeshHome")) {
        // If available, dispatch action with data from local storage
        dispatch(
          webstoryAction(
            WEBSTORY_FETCH_DATA_SUCCESS,
            JSON.parse(localStorage.getItem("SandeshHome"))
          )
        );
      }
      // Construct query string
      const params = new URLSearchParams({
        start,
        limit,
        category_name,
      }).toString();

      // Fetch home primary data using GET request
      return new Promise((resolve, reject) => {
        Get(`${HttpService.WebStoryAPI}?${params}`).then(
          (result) => {
            // Store fetched data in local storage
            localStorage.setItem("SandeshHome", JSON.stringify(result));
            // Dispatch action with fetched home primary data
            dispatch(webstoryAction(WEBSTORY_FETCH_DATA_SUCCESS, result));
            resolve(result);
          },
          (error) => {
            reject(error); // Reject promise with error if fetching fails
          }
        );
      });
    } catch (error) {
      // Dispatch action if there's an error in fetching data
      dispatch(webstoryAction(WEBSTORY_HAVE_ERROR, true));
    }
  };
}
